import React from 'react';
import { useQuery } from '@tanstack/react-query';
import CompanyService from '@app/model/company/service/CompanyService';
import { CompanyQueryKeys } from '@app/model/company/service/CompanyGraphQLQueryKeys';
import CompanyDepartment from '@app/model/company/CompanyDepartment';
import { SelectField, SelectFieldProps } from '@app/site/_form/field/SelectField';


type CompanyDepartmentFieldProps = Omit<SelectFieldProps<number>, 'options' | 'noOptionsText'>

export function CompanyDepartmentField(props: CompanyDepartmentFieldProps) {
	const { data, isSuccess, isLoading, error } = useQuery({
		queryKey: CompanyQueryKeys.departments(),
		queryFn: () => CompanyService.findCompanyDepartments(),
	});


	// Only render the select when we have data
	if (isSuccess && data) {
		return <SelectDepartmentField departments={data} {...props} />;
	}

	// Fallback for any other case
	return null;
};

type FieldProps = CompanyDepartmentFieldProps & {
	departments: CompanyDepartment[];
};

const SelectDepartmentField = React.memo(function SelectDepartmentField<TValue = number>(
  {
    departments,
    ...selectProps
  }: FieldProps,
) {
  // Convert departments to SelectField options format
  const departmentOptions = React.useMemo(() => {
    if (!departments) return [];
    return departments.map(dept => ({
      id: dept.id.toString(),
      label: dept.name,
      value: dept.id as unknown as TValue,
    }));
  }, [departments]);

	  return (
    <SelectField
      {...selectProps}
      noOptionsText="No departments are defined!"
      options={departmentOptions}
    />
  );
});
